import { Button, ButtonVariants, Modal } from '@comptia-sso/core';
import { ReactElement } from 'react';
import { useTranslation, Trans } from 'react-i18next';

import styles from './UpgradeAccountModal.module.scss';

type Props = {
  email?: string;
  isOpen: boolean;
  onClose: () => void;
  onConnectAccount: () => void;
  onCreateAccount: () => void;
};

export const UpgradeAccountModal = ({
  email,
  isOpen,
  onClose,
  onConnectAccount,
  onCreateAccount,
}: Props): ReactElement => {
  const { t } = useTranslation();

  return (
    <Modal
      title={t('UpgradeAccountModal.Title')}
      open={isOpen}
      onClose={onClose}
    >
      <div>
        <p>{t('UpgradeAccountModal.Intro')}</p>
        {email ? (
          <p>
            <Trans
              i18nKey="UpgradeAccountModal.HasAccount"
              values={{ email }}
              components={{
                linktag: <a href={t('Links.LegacyAccount')} />,
              }}
            />
          </p>
        ) : (
          <>
            <p>
              <Trans
                i18nKey="UpgradeAccountModal.NoAccount"
                components={{
                  linktag: <a href={t('Links.LegacyAccount')} />,
                }}
              />
            </p>
            <p>{t('UpgradeAccountModal.Otherwise')}</p>
          </>
        )}
        <p>{t('UpgradeAccountModal.Upgrading')}</p>
        <ul>
          <li>{t('UpgradeAccountModal.Item1')}</li>
          <li>{t('UpgradeAccountModal.Item2')}</li>
          <li>{t('UpgradeAccountModal.Item3')}</li>
        </ul>
      </div>
      <a href={t('Links.LegacyAccount')}>{t('UpgradeAccountModal.WhatLink')}</a>
      <div className={styles.buttons}>
        {email ? null : (
          <Button
            variant={ButtonVariants.Secondary}
            onClick={() => {
              onConnectAccount();
              onClose();
            }}
          >
            {t('UpgradeAccountModal.ConnectAccount')}
          </Button>
        )}
        <Button
          variant={ButtonVariants.Primary}
          onClick={() => {
            email ? onConnectAccount() : onCreateAccount();
            onClose();
          }}
        >
          {t(
            email
              ? 'UpgradeAccountModal.ConnectAccount'
              : 'UpgradeAccountModal.DontHaveAccount',
          )}
        </Button>
      </div>
    </Modal>
  );
};
